import { graphql, useStaticQuery } from 'gatsby'

const query = graphql`
  query SocialMediaLinks {
    site {
      siteMetadata {
        externalUrls {
          discord
        }
      }
    }
  }
`

export default () =>
  useStaticQuery<RecursiveNonNullable<Dkta.Queries.SocialMediaLinksQuery>>(
    query
  )
